import { RefObject, useEffect, useState } from "react";

// Scale font size to fit input container width
export const useInputFontSize = (
  value: string,
  containerRef: RefObject<HTMLElement | null>,
  initialSize: number = 12,
  minSize: number = 9,
): number => {
  const [fontSize, setFontSize] = useState(initialSize);

  useEffect(() => {
    const calculateFontSize = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const style = window.getComputedStyle(container);
      const paddingLeft = parseFloat(style.paddingLeft);
      const paddingRight = parseFloat(style.paddingRight);

      // Check for input element inside to account for its padding
      const inputElement = container.querySelector("input");
      const inputStyle = inputElement
        ? window.getComputedStyle(inputElement)
        : null;
      const inputPaddingLeft = inputStyle
        ? parseFloat(inputStyle.paddingLeft)
        : 0;
      const inputPaddingRight = inputStyle
        ? parseFloat(inputStyle.paddingLeft)
        : 0;

      const availableWidth = container.clientWidth - paddingLeft - paddingRight - inputPaddingLeft - inputPaddingRight;

      const fontFamily = style.fontFamily;

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      if (!context) return;

      let size = initialSize;

      while (size >= minSize) {
        context.font = `${size}px ${fontFamily}`;
        const metrics = context.measureText(value);
        if (metrics.width <= availableWidth) {
            setFontSize(size);
          
            return;
        }
        size -= 0.5;
      }
      setFontSize(minSize);
    };

    calculateFontSize();
    window.addEventListener("resize", calculateFontSize);
    
    return () => window.removeEventListener("resize", calculateFontSize);
  }, [value, containerRef, initialSize, minSize]);

  return fontSize;
};
